$(document).ready(function () {
    $(".faq-accordion-header").click(function () {
      const $accordion_wrapper = $(this).parent();
      const $accordion_content = $(this)
        .parent()
        .find(".faq-accordion-content")
        .first();
      const $accordion_open = "faq-accordion--open";

      // Close all other open accordions
      $(".faq-accordion-content").not($accordion_content).slideUp();
      $(".faq-accordion--open")
        .not($accordion_wrapper)
        .removeClass($accordion_open);

      // If this accordion is already open
      if ($accordion_wrapper.hasClass($accordion_open)) {
        $accordion_content.slideUp(); // Close the content
        $accordion_wrapper.removeClass($accordion_open); // Remove the accordion--open class
      }
      // If this accordion is not already open
      else {
        $accordion_content.slideDown(); // Show this accordion's content
        $accordion_wrapper.addClass($accordion_open); // Add the accordion--open class
      }
    });
  });